import ch from "./ch";
import cz from "./cz";
import da from "./da";
import de from "./de";
import el from "./el";
import en from "./en";
import es from "./es";
import fi from "./fi";
import fr from "./fr";
import he from "./he";
import tw from "./tw";
import hr from "./hr";
import hu from "./hu";
import it from "./it";
import ka from "./ka";
import kr from "./kr";
import nl from "./nl";
import pl from "./pl";
import pt from "./pt";
import ro from "./ro";
import ru from "./ru";
import sa from "./sa";
import se from "./se";
import si from "./si";
import sk from "./sk";
import th from "./th";
import tr from "./tr";
import ua from "./ua";
import vn from "./vn";
import ee from "./ee";
import lt from "./lt";

export default {
    ch,
    cz,
    da,
    de,
    el,
    en,
    es,
    fi,
    fr,
    he,
    tw,
    hr,
    hu,
    it,
    ka,
    kr,
    nl,
    pl,
    pt,
    ro,
    ru,
    sa,
    se,
    si,
    sk,
    th,
    tr,
    ua,
    vn,
    ee,
    lt
};



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js